import axios from "axios";
import { environment } from "../../environments/environment";
import { ListResponse } from "./utils";

export interface PositionInterest {
    job_title_id: number
}

export const listPositionInterests = async (candidate_id: any): Promise<ListResponse<PositionInterest>> => {
    const response = await axios.get<ListResponse<PositionInterest>>(environment.apiUrl+'/api/position_interest?candidate_id='+candidate_id, {
        headers: {
            'Content-Type': 'application/json'
        }
    });

    if(response.status !== 200) {
        throw Error('error');
    };

    return response.data;
};

export const createPositionInterest = async (data: PositionInterest): Promise<ListResponse<PositionInterest>> => {
    const response = await axios.post<ListResponse<PositionInterest>>(environment.apiUrl+'/api/position_interest/', data, {
        headers: {
            'Content-Type': 'application/json'
        }
    });

    if(response.status !== 201) {
        throw Error('error');
    };

    return response.data;
};

export const updatePositionInterest = async (position_interest_id: number, data: PositionInterest): Promise<ListResponse<PositionInterest>> => {
    const response = await axios.put<ListResponse<PositionInterest>>(environment.apiUrl+'/api/position_interest/'+position_interest_id+'/', data, {
        headers: {
            'Content-Type': 'application/json'
        }
    });

    if(response.status !== 200) {
        throw Error('error');
    };

    return response.data;
};

export const deletePositionInterest = async (position_interest_id: number) => {
    const response = await axios.delete(environment.apiUrl+'/api/position_interest/'+position_interest_id+'/', {
        headers: {
            'Content-Type': 'application/json'
        }
    });

    if(response.status !== 204) {
        throw Error('error');
    };
};
